<app-leveltwo [videos]="true" [pageName]="'Home Owners Exemption'">
<div class="General">
  <h3>{{'ApplyforHOX.SearchTitle'|translate}}</h3>


      <p><b style="color:#3165b1">{{'ApplyforHOX.AssessorsTip'|translate}}</b> {{'ApplyforHOX.presentthe'|translate}}</p>
      <!-- <p>{{'ApplyforHOX.Ifyouown'|translate}}</p>
      <p>{{'ApplyforHOX.Call'|translate}} <b>(213)974-3211</b> {{'ApplyforHOX.or'|translate}} <b>(888)807-2111</b> {{'ApplyforHOX.forforms'|translate}}</p> -->
      <p [innerHTML]="'hox.Textv2'|translate"></p>
      <b><p [innerHTML]="'hox.Ifeligible2'|translate"></p></b>

      <p [innerHTML]="'hox.Disclaimer'|translate"></p>

      <p><b>Los Angeles County Assessor's Office</b><br>
      500 W. Temple St. Room 227<br>
      Los Angeles, CA 90012</p>
      <!-- <p [innerHTML]="'hox.Forthesecurity'|translate"></p>
      <p [innerHTML]="'hox.Formoreinfo'|translate"></p> -->
      <p [innerHTML]="'hox.Weapologize'|translate"></p>

</div>
  <app-videos-grid class="Videos" [videos]="videos"></app-videos-grid>
</app-leveltwo>

